// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../static/icons/fontAwesome/check.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../static/icons/fontAwesome/check-white.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox-option {
   display: flex;
   flex-direction: row;
   width: 100%;
   align-items: center;
   /* There was some subtley weird hover stuff happening with options in a multiselect list in a drop down
    this fixed it... */
   background-color: transparent;
   /* padding here messes with clickability - (if user clicks on padding, click doesn't go through), use margins if needed? */
}

.checkbox-option label {
   padding: var(--padding);
   /*Removed so you can't click anywhere beyond the checkbox*/
   /* flex: 1; */
   text-align: left;
   overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;
}

.ecl-checkbox {
   width: 40px;
   height: 40px;
}

.ecl-checkbox input[type="checkbox"] {
   appearance: none;
   width: 100%;
   /* undo the min-width for inputs in GSS */
   min-width: 100%;
   height: 100%;
   margin: 0;
   padding: 0;
}


.ecl-checkbox input[type="checkbox"]:checked::before {
   content: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
}

[data-theme="Dark"] .ecl-checkbox input[type="checkbox"]:checked::before {
   content: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/ECLInputs/ECLCheckBox/ECLCheckBox.css"],"names":[],"mappings":"AAAA;GACG,aAAa;GACb,mBAAmB;GACnB,WAAW;GACX,mBAAmB;GACnB;sBACmB;GACnB,6BAA6B;GAC7B,0HAA0H;AAC7H;;AAEA;GACG,uBAAuB;GACvB,0DAA0D;GAC1D,aAAa;GACb,gBAAgB;GAChB,gBAAgB;GAChB,mBAAmB;GACnB,uBAAuB;AAC1B;;AAEA;GACG,WAAW;GACX,YAAY;AACf;;AAEA;GACG,gBAAgB;GAChB,WAAW;GACX,yCAAyC;GACzC,eAAe;GACf,YAAY;GACZ,SAAS;GACT,UAAU;AACb;;;AAGA;GACG;AACH;;AAEA;GACG;AACH","sourcesContent":[".checkbox-option {\r\n   display: flex;\r\n   flex-direction: row;\r\n   width: 100%;\r\n   align-items: center;\r\n   /* There was some subtley weird hover stuff happening with options in a multiselect list in a drop down\r\n    this fixed it... */\r\n   background-color: transparent;\r\n   /* padding here messes with clickability - (if user clicks on padding, click doesn't go through), use margins if needed? */\r\n}\r\n\r\n.checkbox-option label {\r\n   padding: var(--padding);\r\n   /*Removed so you can't click anywhere beyond the checkbox*/\r\n   /* flex: 1; */\r\n   text-align: left;\r\n   overflow: hidden;\r\n   white-space: nowrap;\r\n   text-overflow: ellipsis;\r\n}\r\n\r\n.ecl-checkbox {\r\n   width: 40px;\r\n   height: 40px;\r\n}\r\n\r\n.ecl-checkbox input[type=\"checkbox\"] {\r\n   appearance: none;\r\n   width: 100%;\r\n   /* undo the min-width for inputs in GSS */\r\n   min-width: 100%;\r\n   height: 100%;\r\n   margin: 0;\r\n   padding: 0;\r\n}\r\n\r\n\r\n.ecl-checkbox input[type=\"checkbox\"]:checked::before {\r\n   content: url(\"../../../../static/icons/fontAwesome/check.svg\")\r\n}\r\n\r\n[data-theme=\"Dark\"] .ecl-checkbox input[type=\"checkbox\"]:checked::before {\r\n   content: url(\"../../../../static/icons/fontAwesome/check-white.svg\")\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
